module.exports = __webpack_public_path__ + "static/Quinario_edit-d331595eaefd9e661b9a317ccb1fc3f5.gif";